import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { ConfigureChart } from '../../components/chart/configure-chart';
import { NestedPageHeader } from '../../components/header/page.header';
import { useBeaconRouter } from '../../route/route.hooks';
import { useQueryParameters } from '../../util/router';

interface RouteParams {
  id: string;
}

interface ConfigureChartPageProps {
  teamId: string;
}

const ConfigureChartPage = (props: ConfigureChartPageProps): ReactElement => {
  const { teamId } = props;
  const { i18n } = useTranslation();
  const { id } = useParams<RouteParams>();

  const queryParams = useQueryParameters();
  const templateId = queryParams.get('templateId');

  const { builder } = useBeaconRouter();

  return (
    <IonPage>
      <NestedPageHeader
        title={i18n.t('common:chart_configure')}
        defaultBackRoute={builder.getTeamHomeRoute(teamId)}
      />
      <IonContent>
        <ConfigureChart
          context={{ teamId }}
          chartId={id === 'new' ? undefined : id}
          templateId={templateId}
        />
      </IonContent>
    </IonPage>
  );
};

export { ConfigureChartPage };
